import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl,  NG_VALUE_ACCESSOR} from '@angular/forms';
import {MetadataUnit} from '@app/graphql-typings/graphql';
import {noop, Subject} from 'rxjs';
import {MetadataUnitService} from '../../services/api/metadata-unit.service';
import {HttpUtilityService} from '@shared/services/api/http-utility-service';
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-metadata-unit-select',
  templateUrl: './metadata-unit-select.component.html',
  styleUrls: ['./metadata-unit-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MetadataUnitSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class MetadataUnitSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() metadataUnits: MetadataUnit[];
  @Input() id: string;
  @Input() appendTo: string;
  @Output() dataLoaded = new EventEmitter<MetadataUnit[]>();

  private readonly REQUEST_PAGE_SIZE = 500;
  private readonly ngUnsubscribe = new Subject<void>();
  private onChange: (value: MetadataUnit) => void = noop;
  onTouched: () => void = noop;

  formControl: FormControl<MetadataUnit | null> = new FormControl<MetadataUnit|null>(null);

  constructor(private httpUtilityService: HttpUtilityService,
              private metadataUnitService: MetadataUnitService) {
  }

  ngOnInit() {
    this.formControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: MetadataUnit) => this.onChange(value));

    if (!this.metadataUnits) {
      this.httpUtilityService.pageUntilComplete(pageInfo => this.metadataUnitService.getMetadataUnits(pageInfo, {}), {first: 0, rows: this.REQUEST_PAGE_SIZE})
        .subscribe(metadataUnits => {
          this.metadataUnits = metadataUnits;
          this.dataLoaded.emit(this.metadataUnits);
        });
    } else {
      this.dataLoaded.emit(this.metadataUnits);
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable({emitEvent: false});
    } else {
      this.formControl.enable({emitEvent: false});
    }
  }

  writeValue(metadataUnit: MetadataUnit): void {
    this.formControl.setValue(metadataUnit, {emitEvent: false});
  }

}
